import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

// Direct path, not the application barrel: this file is inside it.
import useSiteProperties from 'src/compass/application/general/hooks/useSiteProperties';

const NOTE =
  'Note: This is a testing site.  All messages you send will not be sent to the requested recipients.  Instead, messages you request will be sent to you.';

type Props = {
  sx?: SxProps<Theme>;
};

/**
 * Tells the sender, at the top of every compose and Batch Send window, that on this site what they
 * send goes to them and not to the recipients they picked - the backend redirects every email and
 * text to the logged-in user everywhere but Prod (EmailService.SendAllEmailsToLoggedIn). Renders
 * nothing, and takes no space, on Prod or until the site properties load.
 */
export default function TestingSiteNote({ sx }: Props) {
  const { sendAllEmailsToLoggedIn } = useSiteProperties();

  if (!sendAllEmailsToLoggedIn) return null;

  return (
    <Box
      sx={[
        // Information, not a warning: CasPanel's light blue "info" shade, not the app's yellow.
        {
          bgcolor: '#d9f0ff',
          color: 'common.black',
          px: 1.5,
          py: 1,
          borderRadius: 1,
          typography: 'body2',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {NOTE}
    </Box>
  );
}
